var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confidentialite"},[_c('router-link',{attrs:{"to":{name:'Legal'},"tag":"a"}},[_c('i',{staticClass:"fas fa-user-secret"}),_vm._v(" Confidentialité, Conditions…")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }